var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaceinline = function SvgPlaceinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M6.042 0C2.676 0 0 2.708 0 6.115c0 1.66.604 3.233 1.813 4.369.086.087 3.539 3.232 3.625 3.32.345.261.863.261 1.122 0 .086-.088 3.625-3.233 3.625-3.32 1.209-1.136 1.813-2.709 1.813-4.369A5.917 5.917 0 0 0 6.042 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1.5,
    fill: "#fff",
    stroke: "#fff"
  })));
};
export default SvgPlaceinline;